<template>
<div>
  <b-card class="mt-3" header="SKUs em falta">
    <grid-local :name="'missingSkuGrid'" v-bind:url="url" v-bind:columns="columns" v-bind:schemaModelFields="schemaModelFields"></grid-local>
  </b-card>
</div>
</template>

<script>
import GridLocal from '@/components/GridLocal.vue'

export default {
  name: 'mpg',
  components: {
    GridLocal
  },
  data() {
    return {
      url: 'missing/sku',
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      columns: [{
        field: 'sku',
        title: 'SKU'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// missingskus.vue?8343a776